import styled from 'styled-components';


const AUDIO_OPTIONS_HEIGHT = '100%';

export const AudioOptions = styled.div`
  height: ${AUDIO_OPTIONS_HEIGHT};
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: inherit;
  width: inherit;
`;
AudioOptions.displayName = 'AudioOptions';
